<template>
  <div class="o-program is-logged-in" :class="('t-program-page-' + program.id)">



    <app-navigation
      :currentSpace="$tc('web.program.nav_space', programs.length)"
      :hideAuxNavOnDesktop="programs.length <= 1"
      :backButton="showBackButton()">
    </app-navigation>



    <main class="o-program__main" v-if="!access_denied">



      <section class="c-card c-card--program-header t-program-header qa-program-header">

        <div class="c-card--program-header__visual">
          <img v-if="programLogo !== false"
           :src="programLogo"
           :alt="$t('web.program.alt_text_logo')"
           :srcset="programImages[program.id].program + ' 430w, ' +
            programImages[program.id].program_860 + ' 860w'">
        </div>

        <div class="c-card--program-header__info t-program__info">
          <h1 class="c-card--program-header__info__title t-program__info__title">{{ program.name }}</h1>
          <p class="c-card--program-header__info__desc t-program__info__desc">{{ program.description }}</p>
        </div>

      </section><!--END CARD-->



      <template v-for="card in program.program_layout">
        <component v-if="typeof cards[card.id] !== 'undefined'"
          :key="card.id"
          :is="'card-'+cards[card.id].type"
          :card="cards[card.id]"
          :loaded="cardsLoaded.includes(card.id)"
          >
        </component>
      </template>



    </main>
    <main class="o-program__main" v-else>
      <h1 class="c-card--program-header__info__title t-program__info__title">{{ $t('web.program.no_access') }}</h1>
    </main>


    <app-footer></app-footer>



  </div>
</template>










<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'program',
    mounted () {
      this.LOAD_PARTICIPANT(this.$router)

      let programId = this.$route.params.id
      this.LOAD_PROGRAM(programId).then(() => {
        let cardIds = {}
        _.each(this.programDetails[programId].program_layout, (card) => {
          if (typeof this.cards[card.id] === 'undefined') {
            this.UPDATE_CARD_DETAILS({
              id: card.id,
              type: card.type,
              title: null,
              content: null
            })
          }
          cardIds[card.id] = card.id
        })
        this.program = this.programDetails[programId]
        _.each(cardIds, (id) => {
          this.LOAD_CARD({id: id}).then(() => this.cardsLoaded.push(id))
        })
      })
      .catch((error) => {
        if (error.response.status === 403) {
          this.DELETE_PROGRAM_DETAILS(programId)
          this.access_denied = true
        }
      })
      this.program = this.programDetails[programId]
        ? this.programDetails[programId]
        : {}
    },
    data () {
      return {
        program: {},
        access_denied: false,
        cardsLoaded: []
      }
    },
    computed: {
      ...mapGetters(['programDetails', 'cards', 'websiteConfig', 'programDashboard', 'programImages']),
      programLogo () {
        return this.programImages && this.programImages[this.program.id]
        ? this.programImages[this.program.id].program
        : false
      },
      programs () {
        return this.programDashboard.programs
      }
    },
    methods: {
      ...mapActions(['LOAD_PARTICIPANT', 'LOAD_PROGRAM', 'LOAD_CARD']),

      ...mapMutations(['UPDATE_CARD_DETAILS', 'DELETE_PROGRAM_DETAILS']),

      showBackButton () {
        if (this.programs.length > 1 && window.history.length > 1) {
          return true
        }
        return false
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// Program.vue?fb37c63e